import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
export default new Router({
  mode: 'history',
  routes: [{
    path: "/Backend/",
    component: function component() {
      return import("@/Layout/Backend");
    },
    children: [//#region Login
    {
      path: 'Login/Login',
      component: function component() {
        return import("@/Backend/Login/Login");
      }
    }, //#endregion
    //#region Order
    {
      path: 'Order/OrderList',
      component: function component() {
        return import("@/Backend/Order/OrderList");
      }
    }, {
      path: 'Order/OrderDetail',
      component: function component() {
        return import("@/Backend/Order/OrderDetail");
      }
    }, {
      path: 'Order/OrderDetail/:OrderNo',
      component: function component() {
        return import("@/Backend/Order/OrderDetail");
      }
    }, //���~�t�e
    {
      path: 'Order/OrderDeliveryDetail/:OrderNo',
      component: function component() {
        return import("@/Backend/Order/OrderDeliveryDetail");
      }
    }, //#endregion
    //#region �t�e��
    {
      path: 'Delivery/DeliveryList',
      component: function component() {
        return import("@/Backend/Delivery/DeliveryList");
      }
    }, {
      path: 'Delivery/DeliveryDetail',
      component: function component() {
        return import("@/Backend/Delivery/DeliveryDetail");
      }
    }, {
      path: 'Delivery/DeliveryDetail/:?OrderDeliveryNo',
      component: function component() {
        return import("@/Backend/Delivery/DeliveryDetail");
      }
    }, //#endregion
    //#region OrderDailyAmount
    {
      path: 'OrderDailyAmount/OrderDailyAmountList',
      component: function component() {
        return import("@/Backend/OrderDailyAmount/OrderDailyAmountList");
      }
    }, //#endregion
    //#region DailyDelivery
    {
      path: 'DailyDelivery/DailyDeliveryList',
      component: function component() {
        return import("@/Backend/DailyDelivery/DailyDeliveryList");
      }
    }, //#endregion
    //#region CustomerUndelivered
    {
      path: 'CustomerUndelivered/CustomerUndeliveredList',
      component: function component() {
        return import("@/Backend/CustomerUndelivered/CustomerUndeliveredList");
      }
    }, //#endregion
    //#region CustomerDelivered
    {
      path: 'CustomerDelivered/CustomerDeliveredList',
      component: function component() {
        return import("@/Backend/CustomerDelivered/CustomerDeliveredList");
      }
    }, //#endregion
    //#region ItemStatistics
    {
      path: 'ItemStatistics/ItemStatisticsList',
      component: function component() {
        return import("@/Backend/ItemStatistics/ItemStatisticsList");
      }
    }, //#endregion
    //#region ShippingPrice
    {
      path: 'ShippingPrice/ShippingPriceDetail',
      component: function component() {
        return import("@/Backend/ShippingPrice/ShippingPriceDetail");
      }
    }, //#endregion
    //#region TranscationSetting
    {
      path: 'TranscationSetting/TranscationSettingDetail',
      component: function component() {
        return import("@/Backend/TranscationSetting/TranscationSettingDetail");
      }
    }, //#endregion
    //#region Product
    {
      path: 'Product/ProductList',
      component: function component() {
        return import("@/Backend/Product/ProductList");
      }
    }, {
      path: 'Product/ProductDetail',
      component: function component() {
        return import("@/Backend/Product/ProductDetail");
      }
    }, {
      path: 'Product/ProductDetail/:ProductNo',
      component: function component() {
        return import("@/Backend/Product/ProductDetail");
      }
    }, //#endregion
    //#region ProductCategory
    {
      path: 'ProductCategory/ProductCategory',
      component: function component() {
        return import("@/Backend/ProductCategory/ProductCategory");
      }
    }, {
      path: 'ProductCategory/ProductCategory/:ProductCategoryNo',
      component: function component() {
        return import("@/Backend/ProductCategory/ProductCategory");
      }
    }, //#endregion
    //#region CustomPage
    {
      path: 'CustomPage/CustomCategory',
      component: function component() {
        return import("@/Backend/CustomPage/CustomCategory");
      }
    }, {
      path: 'CustomPage/CustomCategory/:CustomPageNo',
      component: function component() {
        return import("@/Backend/CustomPage/CustomCategory");
      }
    }, //#endregion
    //#region CustomPageDataItem
    {
      path: 'CustomPageDataItem/CustomPageDataItemList',
      component: function component() {
        return import("@/Backend/CustomPageDataItem/CustomPageDataItemList");
      }
    }, {
      path: 'CustomPageDataItem/CustomPageDataItemDetail',
      component: function component() {
        return import("@/Backend/CustomPageDataItem/CustomPageDataItemDetail");
      }
    }, {
      path: 'CustomPageDataItem/CustomPageDataItemDetail/:CustomPageDataItemNo',
      component: function component() {
        return import("@/Backend/CustomPageDataItem/CustomPageDataItemDetail");
      }
    }, //#endregion
    //#region SystemPage
    {
      path: 'SystemPage/SystemPageCategory',
      component: function component() {
        return import("@/Backend/SystemPage/SystemPageCategory");
      }
    }, {
      path: 'SystemPage/SystemPageCategory/:SystemPageNo',
      component: function component() {
        return import("@/Backend/SystemPage/SystemPageCategory");
      }
    }, //#endregion
    //#region Navigation
    {
      path: 'Navigator/NavigatorCategory',
      component: function component() {
        return import("@/Backend/Navigator/NavigatorCategory");
      }
    }, {
      path: 'Navigator/NavigatorCategory/:NavigatorItemNo,:NavigatorName',
      component: function component() {
        return import("@/Backend/Navigator/NavigatorCategory");
      }
    }, //#endregion
    //#region Banner
    {
      path: 'Banner/BannerList',
      component: function component() {
        return import("@/Backend/Banner/BannerList");
      }
    }, {
      path: 'Banner/BannerDetail',
      component: function component() {
        return import("@/Backend/Banner/BannerDetail");
      }
    }, {
      path: 'Banner/BannerDetail/:BannerNo',
      component: function component() {
        return import("@/Backend/Banner/BannerDetail");
      }
    }, //#endregion
    //#region PageTemplate
    {
      path: 'PageTemplate/PageTemplateList',
      component: function component() {
        return import("@/Backend/PageTemplate/PageTemplateList");
      }
    }, {
      path: 'PageTemplate/PageTemplateDetail',
      component: function component() {
        return import("@/Backend/PageTemplate/PageTemplateDetail");
      }
    }, {
      path: 'PageTemplate/PageTemplateDetail/:PageTemplateNo',
      component: function component() {
        return import("@/Backend/PageTemplate/PageTemplateDetail");
      }
    }, //#endregion
    //#region News
    {
      path: 'News/NewsList',
      component: function component() {
        return import("@/Backend/News/NewsList");
      }
    }, {
      path: 'News/NewsDetail',
      component: function component() {
        return import("@/Backend/News/NewsDetail");
      }
    }, {
      path: 'News/NewsDetail/:NewsNo',
      component: function component() {
        return import("@/Backend/News/NewsDetail");
      }
    }, //#endregion
    //#region Customer
    {
      path: 'Customer/CustomerList',
      component: function component() {
        return import("@/Backend/Customer/CustomerList");
      }
    }, {
      path: 'Customer/CustomerDetail',
      component: function component() {
        return import("@/Backend/Customer/CustomerDetail");
      }
    }, {
      path: 'Customer/CustomerDetail/:CustomerNo',
      component: function component() {
        return import("@/Backend/Customer/CustomerDetail");
      }
    }, //#endregion
    //#region Import
    {
      path: 'Import/ImportList',
      component: function component() {
        return import("@/Backend/Import/ImportList");
      }
    }, //#endregion
    //#region LoginSession
    {
      path: 'LoginSession/LoginSessionList',
      component: function component() {
        return import("@/Backend/LoginSession/LoginSessionList");
      }
    }, //#endregion
    //#region SystemUser
    {
      path: 'SystemUser/SystemUserList',
      component: function component() {
        return import("@/Backend/SystemUser/SystemUserList");
      }
    }, {
      path: 'SystemUser/SystemUserDetail',
      component: function component() {
        return import("@/Backend/SystemUser/SystemUserDetail");
      }
    }, {
      path: 'SystemUser/SystemUserDetail/:SystemUserNo',
      component: function component() {
        return import("@/Backend/SystemUser/SystemUserDetail");
      }
    }, //#endregion
    //#region MessageTemplate
    {
      path: 'MessageTemplate/MessageTemplateList',
      component: function component() {
        return import("@/Backend/MessageTemplate/MessageTemplateList");
      }
    }, {
      path: 'MessageTemplate/MessageTemplateDetail',
      component: function component() {
        return import("@/Backend/MessageTemplate/MessageTemplateDetail");
      }
    }, {
      path: 'MessageTemplate/MessageTemplateDetail/:MessageTemplateNo',
      component: function component() {
        return import("@/Backend/MessageTemplate/MessageTemplateDetail");
      }
    }, //#endregion
    //#region Coupon
    {
      path: 'Coupon/CouponList',
      component: function component() {
        return import("@/Backend/Coupon/CouponList");
      }
    }, {
      path: 'Coupon/CouponDetail',
      component: function component() {
        return import("@/Backend/Coupon/CouponDetail");
      }
    }, {
      path: 'Coupon/CouponDetail/:CouponNo',
      component: function component() {
        return import("@/Backend/Coupon/CouponDetail");
      }
    }, //#endregion
    //#region FieldOptionMaster
    {
      path: 'FieldOptionMaster/FieldOptionMasterList',
      component: function component() {
        return import("@/Backend/FieldOptionMaster/FieldOptionMasterList");
      }
    }, {
      path: 'FieldOptionMaster/FieldOptionMasterDetail',
      component: function component() {
        return import("@/Backend/FieldOptionMaster/FieldOptionMasterDetail");
      }
    }, {
      path: 'FieldOptionMaster/FieldOptionMasterDetail/:FieldName',
      component: function component() {
        return import("@/Backend/FieldOptionMaster/FieldOptionMasterDetail");
      }
    }, //#endregion
    //#region Word
    {
      path: 'Word/WordList',
      component: function component() {
        return import("@/Backend/Word/WordList");
      }
    }, {
      path: 'Word/WordDetail',
      component: function component() {
        return import("@/Backend/Word/WordDetail");
      }
    }, {
      path: 'Word/WordDetail/:WordName',
      component: function component() {
        return import("@/Backend/Word/WordDetail");
      }
    }, //#endregion
    //#region TagCode
    {
      path: 'TagCode/TagCodeList',
      component: function component() {
        return import("@/Backend/TagCode/TagCodeList");
      }
    }, {
      path: 'TagCode/TagCodeDetail',
      component: function component() {
        return import("@/Backend/TagCode/TagCodeDetail");
      }
    }, {
      path: 'TagCode/TagCodeDetail/:TagCodeNo',
      component: function component() {
        return import("@/Backend/TagCode/TagCodeDetail");
      }
    }, //#endregion
    //#region Configuration
    {
      path: 'Configuration/Configuration',
      component: function component() {
        return import("@/Backend/Configuration/Configuration");
      }
    } //#endregion
    ]
  }, {
    path: '/Test/EcPay/EcPayCheckout',
    component: function component() {
      return import("@/Test/EcPay/EcPayCheckout");
    }
  }, {
    path: '/Test/EcPay/ECPayAuthenticate',
    component: function component() {
      return import("@/Test/EcPay/ECPayAuthenticate");
    }
  }, {
    path: '/Test/EcPay/EcPayCallback',
    component: function component() {
      return import("@/Test/EcPay/EcPayCallback");
    }
  }, {
    path: '/Test/TestFacebook',
    component: function component() {
      return import("@/Test/TestFacebook");
    }
  }, {
    path: "/Test/",
    component: function component() {
      return import("@/Layout/Frontend");
    },
    children: [{
      path: 'Test',
      component: function component() {
        return import("@/Test/Test");
      }
    }, {
      path: 'TestIs',
      component: function component() {
        return import("@/Test/TestIs");
      }
    }, {
      path: 'TestTemplate',
      component: function component() {
        return import("@/Test/TestTemplate");
      }
    }, {
      path: 'TestComponentBase',
      component: function component() {
        return import("@/Test/TestComponentBase");
      }
    }, {
      path: 'TestControlBase',
      component: function component() {
        return import("@/Test/TestControlBase");
      }
    }, {
      path: 'TestRich',
      component: function component() {
        return import("@/Test/TestRich");
      }
    }]
  }, {
    path: "/",
    component: function component() {
      return import("@/Layout/Frontend");
    },
    children: [{
      path: '',
      //������
      component: function component() {
        return import("@/Layout/FrontendHome");
      },
      children: [{
        path: '',
        //������
        component: function component() {
          return import("@/Frontend/CustomPage/ItemList");
        }
      }]
    }, {
      path: 'Page/',
      //����
      component: function component() {
        return import("@/Layout/FrontendInner");
      },
      children: [{
        path: 'Item',
        component: function component() {
          return import("@/Frontend/CustomPage/ItemDetail");
        }
      }, {
        path: ':CustomPageNo',
        component: function component() {
          return import("@/Frontend/CustomPage/ItemList");
        }
      }, {
        path: 'Item/:CustomPageDataItemNo',
        component: function component() {
          return import("@/Frontend/CustomPage/ItemDetail");
        }
      }]
    }, {
      path: 'CustomerArea/',
      //�|���M��
      component: function component() {
        return import("@/Layout/FrontendInner");
      },
      children: [//#region Customer Login
      {
        path: 'Login',
        component: function component() {
          return import("@/Frontend/CustomerArea/Login");
        }
      }, //#endregion
      //#region Customer Logout
      {
        path: 'Logout',
        component: function component() {
          return import("@/Frontend/CustomerArea/Logout");
        }
      }, //#endregion
      //#region   RetrievePassword
      {
        path: 'RetrievePassword',
        component: function component() {
          return import("@/Frontend/CustomerArea/RetrievePassword");
        }
      }, //#endregion
      //#region   ChangePassword
      {
        path: 'ChangePassword',
        component: function component() {
          return import("@/Frontend/CustomerArea/ChangePassword");
        }
      }, //#endregion
      //#region CustomerEdit
      {
        path: 'CustomerEdit',
        component: function component() {
          return import("@/Frontend/CustomerArea/CustomerEdit");
        }
      }, //#endregion 
      //#region CustomerRegisterSuccess
      {
        path: 'CustomerRegisterSuccess',
        component: function component() {
          return import("@/Frontend/CustomerArea/CustomerRegisterSuccess");
        }
      }, //#endregion
      //#region SendingLog
      {
        path: 'Delivery/DeliveryList',
        component: function component() {
          return import("@/Frontend/CustomerArea/Delivery/DeliveryList");
        }
      }, //#endregion
      //#region CustomerMessage
      {
        path: 'CustomerMessage',
        component: function component() {
          return import("@/Frontend/CustomerArea/CustomerMessage");
        }
      }, //#endregion
      //#region OrderLog
      {
        path: 'Order/OrderList',
        component: function component() {
          return import("@/Frontend/CustomerArea/Order/OrderList");
        }
      }, {
        path: 'Order/OrderDetail',
        component: function component() {
          return import("@/Frontend/CustomerArea/Order/OrderDetail");
        }
      }, {
        path: 'Order/OrderDetail/:OrderNo',
        component: function component() {
          return import("@/Frontend/CustomerArea/Order/OrderDetail");
        }
      }, //#endregion
      //#region OnLineService
      {
        path: 'OnLineService',
        component: function component() {
          return import("@/Frontend/CustomerArea/OnLineService");
        }
      } //#endregion
      ]
    }, {
      path: 'Product/',
      //���~����
      component: function component() {
        return import("@/Layout/FrontendInner");
      },
      children: [{
        path: 'ProductList',
        component: function component() {
          return import("@/Frontend/Product/ProductList");
        }
      }, {
        path: 'ProductList/:ProductCategoryNo',
        component: function component() {
          return import("@/Frontend/Product/ProductList");
        }
      }, {
        path: 'ProductDetail/:ProductNo',
        component: function component() {
          return import("@/Frontend/Product/ProductDetail");
        }
      }]
    }, {
      path: 'Shopping/',
      //�ʪ���
      component: function component() {
        return import("@/Layout/FrontendInner");
      },
      children: [//#region ShoppingCart
      {
        path: 'Step1',
        component: function component() {
          return import("@/Frontend/Shopping/Step1");
        }
      }, {
        path: 'Step2',
        component: function component() {
          return import("@/Frontend/Shopping/Step2");
        }
      }, {
        path: 'Step3',
        component: function component() {
          return import("@/Frontend/Shopping/Step3");
        }
      }, {
        path: 'Step3_1',
        component: function component() {
          return import("@/Frontend/Shopping/Step3_1");
        }
      }, {
        path: 'Step4',
        component: function component() {
          return import("@/Frontend/Shopping/Step4");
        }
      } //#endregion
      ]
    }]
  }, {
    path: '*',
    component: function component() {
      return import("@/Frontend/FileNotFound/FileNotFound");
    }
  }]
});